export default __webpack_public_path__ + "static/media/man-team-1.3a61fd90.avif";